module.exports = __webpack_public_path__ + "img/xiangqing.0aea24b0.png";